// Helpers de date de l'onglet Analyse (presentation fr-FR). Purs, sans effet de bord.

// "JJ/MM/AAAA à HH:MM" (sans secondes ; date limite / dechiffrage / dates de reponse).
export const formatDateHeure = (date?: string | null): string | null => {
  if (!date) return null;
  const dateObj = new Date(date);
  if (Number.isNaN(dateObj.getTime())) return null;
  const datePart = dateObj.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const heurePart = dateObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  return `${datePart} à ${heurePart}`;
};
